import { render, staticRenderFns } from "./Passwords.vue?vue&type=template&id=e51ba48e&"
import script from "./Passwords.vue?vue&type=script&lang=js&"
export * from "./Passwords.vue?vue&type=script&lang=js&"
import style0 from "./Passwords.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports